import { render, staticRenderFns } from "./obliqueTags.vue?vue&type=template&id=93954eac&scoped=true"
import script from "./obliqueTags.vue?vue&type=script&lang=js"
export * from "./obliqueTags.vue?vue&type=script&lang=js"
import style0 from "./obliqueTags.vue?vue&type=style&index=0&id=93954eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93954eac",
  null
  
)

export default component.exports